import { AlertTypesEnum } from '../enums/alert-types.enum';
import { SubscriptionTypeEnum } from '../enums/subscription-type.enum';

// Typescript interfaces related to organization settings
// libs/shared/stork/src/lib/enums/organization-settings.enum.ts

export interface IMailSubscriptionContext {
    recipients: string[];
}

export type SubscriptionContextMap = {
    [SubscriptionTypeEnum.MAIL]: IMailSubscriptionContext;
};

export interface IOrganizationSubscription<T extends SubscriptionTypeEnum = SubscriptionTypeEnum> {
    event: AlertTypesEnum;
    type: T;
    context: T extends keyof SubscriptionContextMap ? SubscriptionContextMap[T] : Record<string, unknown>;
}

export interface ITachoSyncDownloadHistory {
    lastDownloadDate: string; // ISO date string
    history: {
        date: string; // ISO date string
        driverIds?: string[];
        vehicleIds?: string[];
        dateFrom?: string;
        dateTo?: string;
        fileUrl: string;
        hash?: string;
    }[];
}
